import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import { App } from './app';
import env from './configs/env';

if (env.api.paths.enableMockServiceWorker) {
  require('./graphql/worker');
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
